module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/GQ-f3024440abb953e1108fdc26dba80a40.png";